module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHBAMAAADOnLEXAAAAG1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACUUeIgAAAACHRSTlMA8DeoGQPnoowBipkAAAAxSURBVAjXY3ArZWAIT2FwbA5gtRBhYJIwDW5UYGBQbLYQYmAAckEcIBfIAQIWBwYGAMZjBj9dqvjGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/down.png
// module id = 32D3
// module chunks = 1